/*
  MiaouLab - bouton "Acheter maintenant"

  Ajoute au panier la variante selectionnee, puis envoie au checkout Shopify.
  Aucun paiement personnalise, aucun contournement : on passe par /cart/add.js
  puis par /checkout.

  L'etat desactive est pose par Liquid, avec exactement les memes conditions que
  le bouton "Ajouter au panier". L'observateur ci-dessous n'est qu'une securite
  pour les changements de variante traites cote client.
*/
(function () {
  'use strict';

  if (window.__miaBuyNow) return;
  window.__miaBuyNow = true;

  function formDe(bouton) {
    var pf = bouton.closest('product-form');
    return pf ? pf.querySelector('form[data-type="add-to-cart-form"]') : null;
  }

  function boutonAjout(form) {
    return form ? form.querySelector('.product-form__submit') : null;
  }

  function zoneErreur(form) {
    var pf = form.closest('product-form');
    return {
      bloc: pf && pf.querySelector('.product-form__error-message-wrapper'),
      texte: pf && pf.querySelector('.product-form__error-message')
    };
  }

  function afficherErreur(form, message) {
    var z = zoneErreur(form);
    if (z.bloc && z.texte) {
      z.texte.textContent = message;
      z.bloc.removeAttribute('hidden');
    }
  }

  function masquerErreur(form) {
    var z = zoneErreur(form);
    if (z.bloc) z.bloc.setAttribute('hidden', '');
  }

  /* Le bouton suit l'etat de "Ajouter au panier", qui porte deja toute la
     logique de disponibilite du theme. On ne la duplique pas. */
  function synchroniser() {
    document.querySelectorAll('[data-mia-buy-now]').forEach(function (btn) {
      var ajout = boutonAjout(formDe(btn));
      if (!ajout) return;
      btn.disabled = ajout.disabled;
      if (btn.dataset.miaObserve === '1') return;
      new MutationObserver(function () {
        btn.disabled = ajout.disabled;
      }).observe(ajout, { attributes: true, attributeFilter: ['disabled'] });
      btn.dataset.miaObserve = '1';
    });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-mia-buy-now]');
    if (!btn) return;
    e.preventDefault();
    if (btn.disabled || btn.getAttribute('aria-busy') === 'true') return;

    var form = formDe(btn);
    if (!form) return;

    var ajout = boutonAjout(form);
    if (ajout && ajout.disabled) return;

    /* Variante relue au moment du clic, jamais une valeur mise en cache. */
    var champ = form.querySelector('.product-variant-id');
    if (!champ || !champ.value || champ.disabled) {
      afficherErreur(form, 'Choisissez une option avant de continuer.');
      return;
    }

    masquerErreur(form);
    btn.setAttribute('aria-busy', 'true');
    btn.disabled = true;

    var data = new FormData(form);
    if (!data.get('quantity')) data.set('quantity', '1');
    data.delete('sections');
    data.delete('sections_url');

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body: data
    })
      .then(function (rep) {
        return rep.json().then(function (json) {
          if (!rep.ok) {
            throw new Error(json.description || json.message || 'Ajout impossible.');
          }
          return json;
        });
      })
      .then(function () {
        window.location.href = '/checkout';
      })
      .catch(function (err) {
        btn.removeAttribute('aria-busy');
        btn.disabled = false;
        afficherErreur(form, err.message || 'Ajout impossible.');
      });
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', synchroniser);
  } else {
    synchroniser();
  }
  /* Le theme re-rend la zone d'achat au changement de variante. */
  document.addEventListener('change', function () {
    window.setTimeout(synchroniser, 0);
  });
})();
